import React, { useRef } from 'react';
import { Outlet } from 'react-router-dom'; // If using React Router
import Header from '../components/Header';
import Footer from '../components/Footer';

const MainLayout = () => {
	const headerRef = useRef(null);
	return (
    <>
		<Header ref={headerRef} />		
		<main>
			<Outlet /> {/* Renders nested routes/components */}
		</main>
		<Footer />
    </>
	);
};

export default MainLayout;